module.exports = __webpack_public_path__ + "static/media/notificationsActive.b5e803fd.svg";